import _ from 'lodash'

const director = (data) => {
	const directors = data.map(({ id, title: { rendered: title }, content: { rendered: body } }) => {
		const regx = /<img[^>]+src\s*=\s*['"]([^'"]+)['"][^>]*>/g
		const images = body.match(regx)

		return {
			id,
			title,
			body,
			image: (!_.isEmpty(images) && images[0]) || null,
		}
	})

	return directors
}

export default director
